import "./agreement-content.js";

[...document.querySelectorAll("#product-nav a")].forEach((e) => {
  const c = e.dataset.controller;
  const a = e.dataset.action;
  if (c) {
    if (new RegExp(`body-${c}`).test(document.body.className)) {
      if (a && !new RegExp(`body-action-${a}`).test(document.body.className)) {
        return;
      }
      e.classList.add("active");
    }
  } else {
    if (e.pathname === location.pathname) {
      e.classList.add("active");
    }
  }
});
